// extracted by mini-css-extract-plugin
export default {"list":"CampaignList_list__tgDRy"};